import styled from 'styled-components';

export const UserNftsContainer = styled.section`
  grid-area: userNfts;
`;
